import { Backdrop, Button, Paper, styled } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import cross from "components/icons/cross-black.svg";
import { apiMain } from "../../../services";
import { IGif } from "../../../services/types";
import PrimaryButton from "../../core/PrimaryButton";
// TODO: Already replaced in 2A0jCZ0v branch
import trashIcon from "components/icons/trashcanIconBlack.png";
import classes from "./EditGalleryPopup.module.scss";

interface IProps {
  galleryID: string;
  onClose: () => void;
}

export const EditGalleryPopup = ({ galleryID, onClose }: IProps) => {
  const [gifs, setGifs] = useState<IGif[]>([]);
  let removePromise: Promise<any> | null = null;

  const handleStopPropagation = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  const getGalleryImages = useCallback(async (galleryID: string) => {
    const response = await apiMain.getGallery(galleryID);
    setGifs(response.gifs);
  }, []);

  const handleRemove = (gifID: string) => async () => {
    if (removePromise !== null) {
      return;
    }

    removePromise = apiMain.deleteGif(gifID);
    await removePromise;
    removePromise = null;

    if (gifs.length === 2) {
      onClose();
    }

    setGifs(prevState => {
      return prevState.filter(gif => {
        return gif.id !== gifID;
      });
    });
  };

  useEffect(() => {
    getGalleryImages(galleryID);
  }, [getGalleryImages, galleryID]);

  return (
    <Backdrop
      open={true}
      sx={{
        zIndex: "var(--popupZ)"
      }}
      onClick={onClose}
    >
      <Paper
        className={classes.editGalleryPopup}
        sx={{
          maxHeight: "90vh",
          maxWidth: "420px",
          width: "100%",
          padding: "2rem",
          borderRadius: "24px",
          zIndex: 22,
          display: "flex",
          flexDirection: "column",
          "@media screen and (max-width: 767px)": {
            maxHeight: "95vh",
            maxWidth: "90%",
            padding: "1rem"
          },
        }}
        onClick={handleStopPropagation}
      >
        <PopupSubheader>
          <h3>Edit Gallery</h3>
          <Button onClick={onClose}><img src={cross} alt="close popup" /></Button>
        </PopupSubheader>
        <div className={classes.gifs}>
          {
            gifs.map(gif => {
              return (
                <div className={classes.gif}>
                  <div className={classes.preview}>
                    <img src={gif.urls.poster} width="44" height="44" alt="" />
                  </div>
                  <div className={classes.name}>{gif.id}</div>
                  <div className={classes.actions}>
                    <PrimaryButton
                      variant="light"
                      size="small"
                      leftIconUrl={trashIcon}
                      onClick={handleRemove(gif.id)}
                    />
                  </div>
                </div>
              );
            })
          }
        </div>
      </Paper>
    </Backdrop>
  );
};

const PopupSubheader = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  "& h3": {
    color: "black !important",
    fontSize: "20px",
    fontWeight: "500",
  },
  "& button": {
    padding: "6px 0",
    minWidth: "32px",
  },
  "& img": {
    width: "32px",
    height: "32px",
  },
});
